<template>
  <page-loader v-if="loadStatus == 'loading'" />
  <div class="contain-section">
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <div class="percentage-box">
          <div class="left">
            <h4>
              {{
                understanding?.right_section && understanding.right_section.length > 0
                  ? understanding.right_section[0].heading
                  : ""
              }}
            </h4>
            <label>Your viking index is <b>{{ vikingResult.percentile }}%</b></label>
          </div>
          <div class="percentage-area">
            <div class="progress-wrapper">
              <div class="percentage-area">
                <DoughnutChart :chart-data="chartData" ChartColor="rgb(51, 119, 255)" :centerTitle="''"
                  centerSubtitle="" :options="options" chartWidth="100%" chartHeight="100%"
                  class="percentage-area-rowx" />
              </div>
              <!-- <svg class="progress-circle" viewBox="0 0 100 100">
                <circle ref="circle" cx="50" cy="50" r="40"></circle>
              </svg>
              <svg
                class="progress-bar"
                viewBox="0 0 100 100"
                :style="{
                  'stroke-dasharray': (vikingResult.percentile / 100) * 250 + ' 1000',
                }"
              >
                <circle cx="50" cy="50" r="40"></circle>
              </svg> -->
              <!-- <text class="progress-text" x="50" y="50"> <b>{{ vikingResult.percentile }}</b><span>(Viking
                    Index)</span></text> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="map-view">
          <div class="map-view-link">
            <h4>
              {{
                understanding?.right_section && understanding.right_section.length > 0
                  ? understanding.right_section[1].heading
                  : ""
              }}
            </h4>
            <p>
              {{ understandingText }}
              {{ vikingResult.poulationGroupCmsInformation.title }}
            </p>
            <router-link to="/vikings/maps" class="view-btn">{{
              understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[1].button_text
                : ""
            }}</router-link>
          </div>
          <div class="view-latitude">
            <img :src="understanding?.right_section && understanding.right_section.length > 0
              ? understanding.right_section[1].main_image[0].url
              : ''
              " alt="view" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col col-sm-12">
    <div class="container-box">
      <div class="light-banner light-new-banner">
        <img :src="understanding && understanding.main_image && understanding.main_image.length
          ? understanding.main_image[0].url
          : ''
          " alt="view" />
      </div>
      <div class="para-container">
        <h3 class="center-heading">{{ understanding ? understanding.heading : "" }}</h3>

        <div class="col-sm-12">
          <div class="row random-box">
            <div class="col-sm-12 col-md-7 col-lg-8 random-parg">
              <h3>
                {{
                  understanding?.right_section && understanding.right_section.length > 0
                    ? understanding.right_section[2].heading
                    : ""
                }}
              </h3>
              <div v-html="understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[2].text
                : ''
                "></div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-4 rand-img">
              <img :src="understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[2].main_image[0].url
                : ''
                " alt="view" class="" />
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="row random-box">
            <div class="col-sm-12 col-md-5 col-lg-4 rand-img">
              <img :src="understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[3].main_image[0].url
                : ''
                " alt="view" class="" />
            </div>
            <div class="col col-sm-12 col-md-7 col-lg-8 random-parg">
              <h3>
                {{
                  understanding?.right_section && understanding.right_section.length > 0
                    ? understanding.right_section[3].heading
                    : ""
                }}
              </h3>
              <div v-html="understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[3].text
                : ''
                "></div>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="row random-box">
            <div class="col-sm-12 col-md-7 col-lg-8 random-parg">
              <h3>
                {{
                  understanding?.right_section && understanding.right_section.length > 0
                    ? understanding.right_section[4].heading
                    : ""
                }}
              </h3>
              <div v-html="understanding?.right_section && understanding.right_section.length > 0
                ? understanding.right_section[4].text
                : ''
                "></div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-4 rand-img">
              <div class="w-full">
                <img :src="understanding?.right_section && understanding.right_section.length > 0
                  ? understanding.right_section[4].main_image[0].url
                  : ''
                  " alt="view" class="" />
              </div>
              <div class="two-path">
                <div class="short">
                  <img :src="understanding?.right_section &&
                    understanding.right_section.length > 0
                    ? understanding.right_section[4].main_image[1].url
                    : ''
                    " alt="view" class="" />
                </div>
                <div class="full">
                  <img :src="understanding?.right_section &&
                    understanding.right_section.length > 0
                    ? understanding.right_section[4].main_image[2].url
                    : ''
                    " alt="view" class="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../styles/pages/results.scss";
import { ref, onMounted } from "vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
import { getVikingUnderstanding } from "@/services/vikings";
export default {
  props: { vikingResult: Object },
  components: { DoughnutChart },
  setup() {
    const loadStatus = ref("loading");
    const understanding = ref({});
    const understandingText = ref({});
    const options = {
      cutout: "70%",
      radius: "100%",
      responsive: true,
    };
    onMounted(async () => {
      understanding.value = await getVikingUnderstanding();
      let regex = /(<([^>]+)>)/gi;
      understandingText.value = understanding.value.right_section[0].text.replace(
        regex,
        ""
      );
      loadStatus.value = "loaded";
    });
    return {
      loadStatus,
      understanding,
      understandingText,
      options
    };
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            data: [this.vikingResult.percentile, 100 - this.vikingResult.percentile],
            backgroundColor: ["rgb(51, 119, 255)", "#ddd"],
          },
        ],
        labels: [],
      };
    },
  },
};
</script>
